export const MentoringCategoriesMap = {
    who: 'Koho chcem mentorovať',
    // topics: 'Témy, ktoré mentorujem',
    // maturity: 'Ako skúsený/á sa cítiš v oblastiach, v ktorých chceš mentorovať',
    how: 'Forma mentoringu',
    duration: 'Koľko času môžem venovať menteemu',
    interests: 'Témy/oblasti, ktoré chcem mentorovať',
    experience: 'Máš skúsenosť s mentorovaním?'
}
